import React, { useState } from 'react';
import { useNavigate,Link } from 'react-router-dom';
import axiosInstance from '../../api/axiosInstance';
import '../../styles/Auth.css';
import {saveRefreshToken} from '../../utils/secureStorage';

function Login() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axiosInstance.post('/auth/login', {
        identifier,
        password,
      });
      if (response.data.refreshToken) {
        await saveRefreshToken(response.data.refreshToken);
      }
      localStorage.setItem('accessToken', response.data.accessToken);

      navigate('/home');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="auth-container">
      <img src="/assets/images/logo-auth.png" alt="Logo" className="auth-logo" />
      <h1>trippin</h1>
      <div className="auth-card">     
        <form onSubmit={handleSubmit}>
          <input
            className="auth-input"
            placeholder="Email or Username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
          />
          <input
            className="auth-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            required
          />
          <p className="forgot-container">
            <Link to="/forgot-password" className="forgot">forgot password?</Link>
          </p>
          <button className="auth-button" type="submit">Login</button>
        </form>
        <p style={{ fontSize: "17px" }}>
          don't have an account? <Link to="/signup" className="auth-link">Sign Up</Link>
        </p>
        {error && <p className="auth-error">{error}</p>}
      </div>
    </div>
  );
}

export default Login;
